import { __generator } from "tslib";
import { all, takeEvery, select, call } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import * as firebase from 'firebase/app';
import 'firebase/messaging';
import { request } from '../../xhr';
import { flagEnabled } from '../flags';
import { registerServiceWorker } from './actions';
function fakeResponse(options) {
    return { success: true };
}
function askPushPermission() {
    return new Promise(function (resolve, reject) {
        Notification.requestPermission().then(function (permission) {
            resolve(permission === 'granted');
        });
    }).catch(function () { return false; });
}
function registerPushToken() {
    var deviceToken, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, firebase.messaging().getToken()];
            case 1:
                deviceToken = _a.sent();
                if (!deviceToken) return [3 /*break*/, 3];
                ddt.log('pwa', 'Obtained push device token: ', deviceToken);
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/register_push_token',
                        data: { device_token: deviceToken },
                    }, fakeResponse)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [3 /*break*/, 5];
            case 4:
                err_1 = _a.sent();
                ddt.log('pwa', 'Failed to obtain push device token: ', err_1);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function enablePushNotifications(registration) {
    var firebaseConfig, messaging, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ddt.log('pwa', 'Attempt to enable push notifications');
                firebaseConfig = {
                    apiKey: 'AIzaSyB0pD98od-qkW_jh6qxx9nSw4g8NJiEZE8',
                    authDomain: 'da-push-demo.firebaseapp.com',
                    databaseURL: 'https://da-push-demo.firebaseio.com',
                    projectId: 'da-push-demo',
                    storageBucket: '',
                    messagingSenderId: '81163614050',
                    appId: '1:81163614050:web:56a10191b7364a0fe6de3b',
                };
                firebase.initializeApp(firebaseConfig);
                messaging = firebase.messaging();
                messaging.usePublicVapidKey('BOFP3zvwYfsSDfL-SVdC08zd2DNPM0uoVfOeUng4b6xXnoCew-scD9OHKs35vlDEWzU-p3_6ewRjCNnflyQDo8M');
                messaging.useServiceWorker(registration);
                return [4 /*yield*/, askPushPermission()];
            case 1:
                result = _a.sent();
                if (!result) return [3 /*break*/, 3];
                ddt.log('pwa', 'Got permission to enable push notifications');
                return [4 /*yield*/, call(registerPushToken)];
            case 2:
                _a.sent();
                messaging.onTokenRefresh(registerPushToken);
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
function handleServiceWorkerRegistration() {
    var allowProgressiveWebApp, pushEnabled, registration, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(flagEnabled, 'progressive_web_app')];
            case 1:
                allowProgressiveWebApp = _a.sent();
                if (!allowProgressiveWebApp) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(flagEnabled, 'web_push')];
            case 2:
                pushEnabled = _a.sent();
                if (!(typeof navigator !== 'undefined' && 'serviceWorker' in navigator)) return [3 /*break*/, 8];
                registration = undefined;
                _a.label = 3;
            case 3:
                _a.trys.push([3, 5, , 6]);
                return [4 /*yield*/, navigator.serviceWorker.register('/sw.js', {
                        scope: '/',
                    })];
            case 4:
                registration = _a.sent();
                return [3 /*break*/, 6];
            case 5:
                err_2 = _a.sent();
                // Failed registration, service worker won't be installed
                ddt.log('pwa', 'Whoops. Service worker registration failed, error:', err_2);
                return [3 /*break*/, 6];
            case 6:
                if (!registration) return [3 /*break*/, 8];
                // Successful registration
                ddt.log('pwa', 'Service worker registration successful');
                if (!pushEnabled) return [3 /*break*/, 8];
                return [4 /*yield*/, call(enablePushNotifications, registration)];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(registerServiceWorker, handleServiceWorkerRegistration),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map